import axios from 'axios';
import * as firebase from 'firebase';

const getAllSettings = async () => {
  const idToken = await firebase.auth().currentUser.getIdToken(true);
  const response = await axios.get(`${global.API_URL}/settings`, { headers: { authorization: idToken } });
  return response.data;
};

const createSetting = async (fields) => {
  const idToken = await firebase.auth().currentUser.getIdToken(true);
  const response = await axios.post(`${global.API_URL}/settings/${fields.id}`, { authToken: idToken, fields });
  return response.data;
};

const getSetting = async (id) => {
  const idToken = await firebase.auth().currentUser.getIdToken(true);
  const response = await axios.get(`${global.API_URL}/settings/${id}`, { headers: { authorization: idToken } });
  return response.data;
};

const updateSetting = async (fields) => {
  const idToken = await firebase.auth().currentUser.getIdToken(true);
  const response = axios.put(`${global.API_URL}/settings/${fields.id}`, { authToken: idToken, fields });
  return response.data;
};

const deleteSetting = async (id) => {
  const idToken = await firebase.auth().currentUser.getIdToken(true);
  const response = await axios.delete(`${global.API_URL}/settings/${id}`, { headers: { authorization: idToken } });
  return response.data;
};

export {
  getAllSettings,
  getSetting,
  createSetting,
  updateSetting,
  deleteSetting,
};
